<template>
	<v-card color="nyLightYellow" class="mb-3" >
		<v-card-text class="pb-0">
			<div
				class="orange--text text--darken-2 TitleFont text-center mb-2 CardTitleSize"
			>
				Prenota l'incontro conoscitivo
			</div>
			<div class="poppins-regular" style="font-size: 0.9rem;">
				<div class="mb-2">
					<v-icon small color="orange darken-2" class="mr-2"
						>fas fa-fw fa-seedling
					</v-icon>
					Una videochiamata
					<span class="poppins-bold">gratuita</span>
					di circa 20 minuti per condividere le tue esigenze e
					scoprire il percorso personalizzato proposto dal tuo
					nutrizionista
				</div>
				<div class=" mb-2">
					<v-icon small color="orange darken-2" class="mr-2"
						>fas fa-fw fa-calendar-alt
					</v-icon>
					Puoi fissarlo direttamente tu scegliendo il momento che
					preferisci tra le proposte qui sotto.
				</div>
				<div class="mb-2">
					<v-icon small color="orange darken-2" class="mr-2"
						>fas fa-fw fa-comment-alt-dots
					</v-icon>
					Se non ti è possibile in nessuna delle proposte
					<router-link
						to="/Chat"
						class="poppins-bold grey--text text--darken-2"
					>
						scrivi
						{{
							NutritionistProfile.Gender === 1
								? "al tuo "
								: "alla tua "
						}}
						nutritionista in chat
					</router-link>
					!
				</div>
			</div>
		</v-card-text>

		<template v-if="$vuetify.breakpoint.mdAndUp">
			<v-divider class="mx-4 mt-5 mb-3"></v-divider>
			<div class="orange--text TitleFont text-center mb-2 CardTitleSize">
				Scegli la data e l'ora
			</div>
		</template>
		<CreateEventFromCalendar
			@bookingCreated="$emit('bookingCreated', $event)"
			@noAvailableSlots="NoAvailableSlotsFound = true"
			:BookingTypeId="bookingTypeId"
		>
		</CreateEventFromCalendar>
		<template v-if="0">
			<v-divider></v-divider>
			<div
				class="pa-3 poppins-medium pointer"
				style="font-size: 1rem"
				@click="
					bookingTypeId === BookingTypesEnum.FREE
						? (bookingTypeId = BookingTypesEnum.NORMAL)
						: (bookingTypeId = BookingTypesEnum.FREE)
				"
			>
				<span v-if="bookingTypeId === BookingTypesEnum.FREE"
					>Preferisci prenotare direttamente una visita
					nutrizionale?</span
				>
				<span v-else
					>Preferisci prenotare prima l’incontro conoscitivo
					gratuito?</span
				>
			</div>
		</template>
	</v-card>
</template>
<script>
import CreateEventFromCalendar from "@/views/Patients/components/CreateEventFromCalendar.vue";
import { BookingTypesEnum } from "@/components/NutriYou/nutriYouBookingTypesEnum";

export default {
	name: "BookDynamicIcOrVn",
	components: { CreateEventFromCalendar },
	props: {
		NoAvailableSlotsFound: {},
		NutritionistProfile: {},
		bookingTypeId: {}
	},
	created() {
		this.BookingTypesEnum = BookingTypesEnum;
	}
};
</script>
